import React from 'react';

const ReceiptKotComponent = ({
  selectedDate,
  sysInfo,
  clientInfo,
  generalsettings,
  receiptData,
  username
}) => {

  // Don't render if no receipt data
  if (!receiptData) {
    return null;
  }

  const createDashedLine = (width = 43) => {
    return '-'.repeat(width);
  };

  const formatCurrency = (amount) => {
    return amount.toFixed(2);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const formatTime = () => {
    return new Date().toLocaleTimeString('en-IN', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  
  return (
    <div className="flex h-screen bg-background">
      <div className="p-4 bg-gray-500">
        <div
          id="receiptDiv"
          className="bg-white p-2 font-mono text-sm"
          style={{ 
            width: '302px', // 80mm = ~302px at 96dpi
            minHeight: 'auto',
            fontFamily: 'Courier New, monospace',
            fontSize: '11px',
            lineHeight: '1.1',
            margin: '0 auto',
            boxSizing: 'border-box'
          }}
        >
          {/* Header Section */}
          <div className="text-center mb-2">
            <div className="font-bold text-sm leading-tight">
              {generalsettings?.FirstName} {generalsettings?.LastName}
            </div>
            <div className="font-bold text-xs leading-tight">
              {generalsettings?.MobileNo1}
            </div>
            <div className="font-bold text-xs leading-tight" style={{ wordBreak: 'break-word' }}>
              {generalsettings?.AddressLine1} {generalsettings?.AddressLine2} {generalsettings?.Place}
            </div>
            <div className="font-bold text-xs leading-tight" style={{ wordBreak: 'break-word' }}>
              GST No: {generalsettings?.GstNo}
            </div>
            
          </div>

          {/* Receipt Details */}
          <div>
            <div className="flex justify-between text-xs">
              <span className='font-bold'>Receipt No:</span>
              <span className="font-bold">{receiptData.receiptNumber}</span>
            </div>
            <div className="flex justify-between text-xs">
              <span className='font-bold'>Date:</span>
              <span className='font-bold'>{formatDate(selectedDate)}</span>
            </div>
            <div className="flex justify-between text-xs">
              <span className='font-bold'>Time:</span>
              <span className='font-bold'>{formatTime()}</span>
            </div>
            <div className="flex justify-between text-xs">
              <span className='font-bold'>Payment Mode:</span>
              <span className='font-bold'>{receiptData.paymentMethod}</span>
            </div>
            <div className="text-xs" style={{ fontFamily: 'monospace' }}>
              {createDashedLine()}
            </div>
          </div>

          {/* Patient Info - Only show if single patient */}
          {!receiptData.isMultiplePatients && (
            <div>
              <div className="flex justify-between text-xs">
                <span className='font-bold'>Patient:</span>
                <span className="font-bold text-right" style={{ maxWidth: '70%', wordBreak: 'break-word' }}>
                  {receiptData.patients[0]?.patientName}
                </span>
              </div>
              <div className="text-xs" style={{ fontFamily: 'monospace' }}>
                {createDashedLine()}
              </div>
            </div>
          )}

          {/* Multiple Patients Info */}
          {receiptData.isMultiplePatients && (
            <div>
              <div className="text-xs font-bold">
                MULTIPLE PATIENTS ({receiptData.patients.length})
              </div>
              <div className="text-xs" style={{ fontFamily: 'monospace' }}>
                {createDashedLine()}
              </div>
            </div>
          )}

          {/* Department-wise Payment Summary */}
          <div>
            <div className="text-xs">
              <div className="flex justify-between font-bold">
                <span className='font-bold'>DEPARTMENT</span>
                <span className='font-bold'>AMOUNT</span>
              </div>
            </div>
            <div className="text-xs" style={{ fontFamily: 'monospace' }}>
              {createDashedLine()}
            </div>
            
            {receiptData.departmentTotals.map((dept, index) => (
              <div key={index} className="mb-2">
                <div className="flex justify-between text-xs">
                  <span className="font-bold flex-1" style={{ maxWidth: '70%', wordBreak: 'break-word' }}>
                    {dept.departmentName} ({dept.billCount} Bills)
                  </span>
                  <span className="font-bold text-right whitespace-nowrap">₹{formatCurrency(dept.totalPaying)}</span>
                </div>
                
                {/* Show invoice numbers for this department */}
                <div className="ml-2 text-xs">
                  {dept.bills.map((bill, billIndex) => (
                    <div key={billIndex} className="flex justify-between">
                      <span className='font-bold' style={{ maxWidth: '65%', wordBreak: 'break-word' }}>
                        Inv-{bill.invoiceNo}
                      </span>
                      <span className="font-bold text-right">₹{formatCurrency(bill.payingAmount)}</span>
                    </div>
                  ))}
                </div>
                
                {/* Show remaining amount if any */}
                {dept.totalRemaining > 0 && (
                  <div className="ml-2 text-xs text-gray-600">
                    <div className="flex justify-between">
                      <span>Remaining Balance:</span>
                      <span>₹{formatCurrency(dept.totalRemaining)}</span>
                    </div>
                  </div>
                )}
              </div>
            ))}
            
            <div className="text-xs" style={{ fontFamily: 'monospace' }}>
              {createDashedLine()}
            </div>
          </div>

          {/* Payment Summary */}
          <div>
            <div className="flex justify-between text-xs">
              <span className='font-bold'>Total Bills:</span>
              <span className='font-bold'>{receiptData.billCount}</span>
            </div>
            <div className="flex justify-between text-xs">
              <span className='font-bold text-lg'>Total Amount:</span>
              <span className='font-bold text-lg'>₹{formatCurrency(receiptData.totalDueAmount)}</span>
            </div>
            <div className="flex justify-between font-bold text-xs">
              <span className='font-bold text-lg'>Amount Paid:</span>
              <span className='font-bold text-lg'>₹{formatCurrency(receiptData.totalPayingAmount)}</span>
            </div>
            {receiptData.totalRemainingAmount > 0 && (
              <div className="flex justify-between font-bold text-xs">
                <span className='font-bold text-md'>Balance Due:</span>
                <span className='font-bold text-md'>₹{formatCurrency(receiptData.totalRemainingAmount)}</span>
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="text-xs" style={{ fontFamily: 'monospace' }}>
            {createDashedLine()}
          </div>
          <div className="pt-2 text-center">
            <div className="text-xs mb-1 font-bold">
              Thank You for Your Payment!
            </div>
            <div className="text-xs mb-1 font-bold">
              Printed By User: {username || sysInfo?.userName}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReceiptKotComponent;